import { render, staticRenderFns } from "./leftImgNews.vue?vue&type=template&id=4c1a0c14&scoped=true&"
import script from "./leftImgNews.vue?vue&type=script&lang=js&"
export * from "./leftImgNews.vue?vue&type=script&lang=js&"
import style0 from "./leftImgNews.vue?vue&type=style&index=0&id=4c1a0c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a0c14",
  null
  
)

export default component.exports